import { AlkLogger } from '@alk/core';
import { ERoutes } from '../../enums';
import { injectable } from 'inversify';
import { IRouterListenerService } from './router-listener.interface';

@injectable()
export class RouterListenerServiceMock implements IRouterListenerService {

    init(): void {
        AlkLogger.info('RouterListenerService mock created');
    }

    getStoredRoute(): Promise<ERoutes> {
        return Promise.resolve('/trading');
    }
}
